import { isExactLawFirmNameMatch } from "../../../../globals/utils/lawFirmNameNormalize";

export const EXACT_LAW_FIRM_DUPLICATE_MESSAGE =
  "This law firm already exists. Select the existing firm to continue.";

/** Parse fuzzy-match law firm API response into a normalized shape. */
export function parseFuzzyLawFirmMatch(fuzzyRes, fallbackName) {
  const matchedId =
    fuzzyRes?.match?.lawfirm_id ?? fuzzyRes?.law_firm?.id ?? fuzzyRes?.lawfirm_id;
  const matchedName =
    fuzzyRes?.match?.name ?? fuzzyRes?.law_firm?.name ?? fuzzyRes?.law_firm_name ?? "";
  const hasMatch = Boolean(
    (fuzzyRes?.match != null && matchedId != null) ||
      (fuzzyRes?.matched && matchedId != null)
  );
  const exactMatch =
    fuzzyRes?.exact_match === true ||
    (hasMatch && isExactLawFirmNameMatch(fallbackName, matchedName));
  return {
    matchedId,
    matchedName: matchedName || fallbackName,
    hasMatch,
    exactMatch,
  };
}

/** POST /fuzzy-match-lawfirm and parse the response. */
export async function requestLawFirmFuzzyMatch(apiClient, firmName) {
  const fuzzyRes = await apiClient("/fuzzy-match-lawfirm", "POST", { name: firmName });
  return parseFuzzyLawFirmMatch(fuzzyRes, firmName);
}

/** Shape for fuzzy-match dialog state, or null when there is no match. */
export function buildLawFirmFuzzyDialogResult(parseResult, fallbackName) {
  if (!parseResult?.hasMatch) return null;
  return {
    id: parseResult.matchedId,
    name: parseResult.matchedName || fallbackName,
    exactMatch: parseResult.exactMatch,
  };
}

export function notifyExactLawFirmDuplicate(exactMatch, toast) {
  if (!exactMatch) return false;
  toast.error(EXACT_LAW_FIRM_DUPLICATE_MESSAGE);
  return true;
}
